import React from 'react';
import {
  createStyles,
  IconButton,
  Menu,
  MenuItem,
  WithStyles,
  withStyles
} from '@material-ui/core';
import {LineWeight as LineWeightIcon} from '@material-ui/icons';

import {ViewModeContext} from '../../contexts/viewMode';
import {ViewMode} from '../../models/viewMode';

interface State {
  menu?: any;
}

const styles = () =>
  createStyles({
    white: {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white'
      }
    },
    black: {
      backgroundColor: '#303030',
      '&:hover': {
        backgroundColor: '#303030'
      }
    },
    blue: {
      backgroundColor: '#327db0',
      '&:hover': {
        backgroundColor: '#327db0'
      }
    }
  });

class MainViewMode extends React.Component<WithStyles<typeof styles>, State> {
  state = {
    menu: undefined
  };

  /**
   * Открыть меню
   * @param event
   */
  openMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({menu: event.currentTarget});
  };

  /**
   * Закрыть меню
   */
  closeMenu = () => {
    this.setState({menu: undefined});
  };

  render() {
    const {menu} = this.state;

    return (
      <ViewModeContext.Consumer>
        {({viewMode, changeViewMode}) => (
          <React.Fragment>
            <IconButton color='inherit' onClick={this.openMenu}>
              <LineWeightIcon />
            </IconButton>
            <Menu
              anchorEl={menu}
              open={Boolean(menu)}
              onClose={this.closeMenu}
              onClick={this.closeMenu}
              getContentAnchorEl={null}
              anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
              transformOrigin={{vertical: 'top', horizontal: 'center'}}
            >
              <MenuItem
                onClick={() => changeViewMode(ViewMode.BASE)}
                selected={viewMode === ViewMode.BASE}
              >
                Стандартный
              </MenuItem>
              <MenuItem
                onClick={() => changeViewMode(ViewMode.SLIM)}
                selected={viewMode === ViewMode.SLIM}
              >
                Компактный
              </MenuItem>
            </Menu>
          </React.Fragment>
        )}
      </ViewModeContext.Consumer>
    );
  }
}

export default withStyles(styles, {name: 'MainMode'})(MainViewMode);
